import * as React from "react"
const SvgFolders = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M3 21.714q-.824 0-1.413-.587A1.93 1.93 0 0 1 1 19.714v-12q0-.424.288-.712A.97.97 0 0 1 2 6.714q.424 0 .712.288A.97.97 0 0 1 3 7.714v12h16q.424 0 .712.288a.97.97 0 0 1 .288.712.97.97 0 0 1-.288.713.97.97 0 0 1-.712.287zm4-4q-.824 0-1.412-.587A1.93 1.93 0 0 1 5 15.714v-11q0-.825.588-1.412A1.93 1.93 0 0 1 7 2.714h4.175a1.98 1.98 0 0 1 1.4.575L14 4.714h7q.824 0 1.413.588.587.587.587 1.412v9a1.93 1.93 0 0 1-.587 1.413 1.93 1.93 0 0 1-1.413.587zm0-2h14v-9h-7.825l-2-2H7z" />
  </svg>
)
export default SvgFolders
